import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelProject.${param}`)
export default (form = {}) => {
  const column = [
    {
      label: i18n('projectId'),
      field: 'projectid',
      dictField: 'projectName',
      formOption: {
        rules: 'required',
        type: 'select',
        dictCode: 'developerproject',
      },
    },
    {
      label: i18n('type'),
      field: 'projecttype',
      dictField: 'projecttypeName',
      formOption: {
        hide: true,
      },
    },
    {
      label: i18n('expense'),
      field: 'expense',
      hide: vm.disabled,
      formOption: {
        type: 'number',
      },
    },
    {
      label: i18n('status'),
      field: 'status',
      dictField: 'statusName',
      formOption: {
        type: 'select',
        dictBizCode: 'project_status',
      },
    },
    {
      label: i18n('startDate'),
      field: 'startDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        type: 'date',
      },
    },
    {
      label: i18n('endDate'),
      field: 'endDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        hide: form.status !== '0',
        type: 'date',
      },
    },
  ]
  return column
}
